<div class="navbar">
  <a [href]="'/?uuid=' + this.consentDataService.getConsentdata().uuid">
    <img src="../../../../assets/img/SOSInt_Logo2019_UrgentRed_RGB.svg" height="40" width="160">
  </a>
</div>
